import {
    type GetCompanyUpdateRequestResponseType,
    type GetCompanyUpdateRequestRequestType
} from "./type";
import {
    request
} from "../request";

const getCompanyUpdateRequest = async (
    params: GetCompanyUpdateRequestRequestType
): Promise<GetCompanyUpdateRequestResponseType> => {
    return await request<GetCompanyUpdateRequestResponseType>(
        `/request/getCompanyUpdateRequest?requestID=${params.requestID}`,
        {
            method: "GET"
        }
    );
};
export default getCompanyUpdateRequest;
